<template>
    <div>
        <b-row>
            <b-col cols="4"  v-if="file">
                <div class="info-card px-2 py-1 my-1">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                    ملف محضر الجلسة الإدارية {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : ''  }}  الموافقة على حل المنظمة
                    </div>
                    <div>
                    <b-button
                    
                        variant="flat-info"
                        v-b-toggle.doc-view
                        class="btn-icon mx-25"
                        v-b-tooltip.hover.v-info.bottom
                        title="عرض المستند المرفوع"
                        :to="{ name: 'file-view', query: { ep:file  } }"
                    >
                        <feather-icon icon="EyeIcon"
                    /></b-button>
                    </div>
                </div>
                <div>
                    <hr />
                </div>
                </div>
            </b-col> 
            
            <b-col md="4" cols="12" v-else>
                <info-card
                label="رقم محضر الجلسة الإدارية التي تمّ خلالها الموافقة على حل المنظمة"
                :value="data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label :''"
                />
            </b-col>     
        
            <b-col md="4" cols="12">
                <info-card label="اسم المصفي المعين من قبل المُنظمة"
                :value="data.name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="المنظمة الذي تمَّ اختيارها لتؤول أموال المُنظمة طالبة الحل لها"
                :value="data.alternative_ngo_id ? data.alternative_ngo_id.name_ar : ''"
                />
            </b-col>
        </b-row>
    </div>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";  
  import axios from "@axios";
  
  import router from "@/router";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton
    },
    props: {
        data : Object ,
    },
    data() {
        return {
            file: '',
        }
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    
    watch: {
        data: {
        handler: async function(newVal, oldVal) {
            
            const currentRoute = router.currentRoute.path.includes('ministry')
            if(currentRoute){
                console.log("currentRoute" , currentRoute)
                await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.meeting_minute_id.id}`).then((res) => this.file=res.data.data.file);
            }
            else{
                this.file=null
            }
        },
        deep: true
        }
    },
  };
  </script>